// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__Eq4FV","upload":"Small_upload__2XNWS","imageWrap":"Small_imageWrap__20XET","removeBtn":"Small_removeBtn__15c9s"};